import { createApi } from '@redux/createApi';
import { createSlice } from '@reduxjs/toolkit';

const tags = {
  getLimits: 'getLimits',
  setPayoutLimit: 'setPayoutLimit',
  setConversionLimit: 'setConversionLimit',
  deleteLimit: 'deleteLimit',
  getFiatAssets: 'getFiatAssets',
  getCryptoAssets: 'getCryptoAssets',
  getPrice: 'getPrice',
};

export const limitsApi = createApi({
  reducerPath: 'limitsApi',
  tagTypes: [tags.getLimits],
  endpoints: (builder) => ({
    getFiatAssets: builder.query({
      query: () => {
        return ({
          method: 'get', url: `/admin/fiat-assets`,
        });
      },
      providesTags: [tags.getFiatAssets],
      serializeQueryArgs: ({ queryArgs }) => {
        return { ...queryArgs };
      },
    }),
    getCryptoAssets: builder.query({
      query: () => {
        return ({
          method: 'get', url: `/admin/assets`,
        });
      },
      providesTags: [tags.getCryptoAssets],
      serializeQueryArgs: ({ queryArgs }) => {
        return { ...queryArgs };
      },
    }),
    getLimits: builder.query({
      query: () => {
        return ({
          method: 'get', url: `/limit/list`,
        });
      },
      providesTags: [tags.getLimits],
      serializeQueryArgs: ({ queryArgs }) => {
        return { ...queryArgs };
      },
      transformResponse: (data) => {
        return data ? data.data || [] : [];
      },
    }),
    setPayoutLimit: builder.mutation({
      query: ({ asset, amount, provider }) => {
        const body = {
          'asset': asset,
          'amount': amount,
          provider_type: provider,
        };
        return ({
          method: 'post', url: `/limit/payout`,
          body: body,
        });
      },
      providesTags: [tags.setPayoutLimit],
      invalidatesTags: [tags.getLimits],
    }),
    setConversionLimit: builder.mutation({
      query: ({ baseAsset, quoteAsset, amount, side}) => {
        const body = {
          'base_asset': baseAsset,
          'quote_asset': quoteAsset,
          'amount': amount,
          'side': side,
        };

        return ({
          method: 'post', url: `/limit/convert`,
          body: body,
        });

      },
      providesTags: [tags.setConversionLimit],
      invalidatesTags: [tags.getLimits],
    }),
    deleteLimit: builder.mutation({
      query: ({ id }) => {
        return ({
          method: 'delete', url: `/limit/delete-regular-limit/${encodeURIComponent(id)}`,
        });
      },
      providesTags: [tags.deleteLimit],
      invalidatesTags: [tags.getLimits],
    }),
  }),
});

export const limitsParams = createSlice({
  name: 'limitsParams',
  initialState: {
    page: 1,
    limit: 100,
    filter: 'ALL',
    start: new Date(new Date().setDate(0)),
    end: new Date(),
  },
  reducers: {
    setParams: (state, action) => {
      return { ...state, ...action.payload };
    },

  },
});
export const {
  useGetLimitsQuery,
  useSetPayoutLimitMutation,
  useDeleteLimitMutation,
  useSetConversionLimitMutation,
  useGetFiatAssetsQuery,
  useGetCryptoAssetsQuery,
  useGetPriceMutation,
} = limitsApi;

export const { setParams } = limitsParams.actions;
export const limitsParamsReducer = limitsParams.reducer;
export const limitsParamsSelector = (state) => state.limitsParams;